import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import  Swal  from 'sweetalert2';
@Component({
  selector: 'app-subtopic-detail',
  templateUrl: './subtopic-detail.component.html',
  styleUrls: ['./subtopic-detail.component.css']
})
export class SubtopicDetailComponent implements OnInit {
  @Input() topic={topics:[],name:"", hasTemplates:false,subtopics:[],selectedSubTopics:[],isSelected:false}
  @Output() subTopicValue = new EventEmitter<any>()
  @Input() selectedSubTopicCount=0

  constructor() { }

  ngOnInit(): void {
  }

   updateSelection(subTopicInfo:any){
      this.subTopicValue.emit(subTopicInfo)
    }
    alertNeedToRegister(subTopicName:string){
      Swal.fire("Oops","You need to register to include \""+subTopicName+"\" into the worksheet",'info')
    }
}
